import BaseDialog from 'components/BaseDialog'
import React, { useCallback, useState } from 'react'
import { createModal } from 'react-modal-promise'
import { InjectedModalProps } from 'utils-next/modals'
import { ExtendableStyles } from 'utils-next/types'

import { Button, TextField, Typography } from '@mui/material'

import { getUserName, User } from '../../../../../entities-next/user'

const CONFIRMATION_TEXT = 'delete this user'

export type DeleteUserModalProps = ExtendableStyles &
  InjectedModalProps<boolean> & {
    corporate: User
  }

export function DeleteUserModal({ isOpen, onResolve, corporate }: DeleteUserModalProps) {
  const userReference = getUserName(corporate)

  const [confirmationInput, setConfirmationInput] = useState('')
  const handleConfirmationInput = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmationInput(e.target.value)
  }, [])

  const handleCancel = useCallback(() => {
    onResolve(false)
  }, [onResolve])
  const handleConfirm = useCallback(() => {
    onResolve(true)
  }, [onResolve])

  const isConfirmationDisabled = confirmationInput !== CONFIRMATION_TEXT
  return (
    <BaseDialog
      title="Are you sure you want to delete this user?"
      description={
        <div>
          <Typography>
            Deleting user <strong>{userReference}</strong> and all his/her data (deals, criteria...) is irreversible.
            <br />
            <br />
            To confirm, please type <em>{CONFIRMATION_TEXT}</em> in the input below.
          </Typography>
          <TextField margin="dense" value={confirmationInput} onChange={handleConfirmationInput} autoFocus />
        </div>
      }
      open={isOpen}
      onClose={handleCancel}
      actions={
        <Button onClick={handleConfirm} disabled={isConfirmationDisabled} variant="outlined">
          Delete user
        </Button>
      }
    />
  )
}

export const showDeleteUserModal = createModal<DeleteUserModalProps>(DeleteUserModal)
